export const messages = {
  en: {
    printOweFee: {
      paymentNotice: 'Payment Notice',
      owner: 'Owner',
      printTime: 'Print Time',
      chargeObject: 'Charge Object',
      itemName: 'Item Name',
      feePeriod: 'Fee Period',
      unit: 'Unit',
      areaUsage: 'Area/Usage',
      unitPrice: 'Unit Price',
      amount: 'Amount',
      amountInWords: 'Amount in Words',
      noData: 'No payment notice data available'
    }
  },
  zh: {
    printOweFee: {
      paymentNotice: '缴费通知单',
      owner: '业主',
      printTime: '打印时间',
      chargeObject: '收费对象',
      itemName: '项目名称',
      feePeriod: '费用期间',
      unit: '单位',
      areaUsage: '面积/用量',
      unitPrice: '单价',
      amount: '金额',
      amountInWords: '大写人民币（元）',
      noData: '当前没有缴费通知数据'
    }
  }
}